<template>
  <div>
    <vxe-grid
      ref="skuTable"
      auto-resize
      highlight-hover-row
      resizable
      show-footer
      size="mini"
      cell-class-name="align-top"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :max-height="635"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :edit-rules="editRules"
      :footer-method="() => footerData"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabled"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="remove(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            v-if="!disabledPrint"
            :content="$l('INDEX.btn_tips_printer') || '打印'"
            placement="top"
          >
            <i class="el-icon-printer tool-btn" @click="printView(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <div>{{ row.goodsName }}</div>
          <div>{{ row.goodsNameEn }}</div>
          <div>
            <span>SIZE:</span><span>{{ row.goodsSize }}</span>
          </div>
          <div>
            <span>COLOR:</span
            ><span>{{ row.goodsColor }}{{ row.goodsColorEn }}</span>
          </div>
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <div>{{ row.ncNo }}</div>
          <div>{{ row.hxSkuNo }}</div>
        </div>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg',
          ]"
          style="width:60px;height:60px;"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" style="width:60px;height:60px;" />
          </div>
        </el-image>
      </template>
    </vxe-grid>
    <printView ref="printViewRef"> </printView>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import printView from '../print-view'
import { format, add, multiply, divide } from '@/libs/util.number.js'
export default {
  props: {
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disabledPrint: { typ: Boolean, default: false },
  },
  components: { printView },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: this.disabled ? { query: () => this.$emit('reload') } : null,
        zoom: true,
        custom: true,
      },
      tableData: [],
      calcTableData: [],
      format: (number) => format(number),
      tableColumns: tableColumns(this),
      editRules: {
        inCtnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnLength: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnWidth: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnHeight: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ctnGrossWeight: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        ftyPrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.calcTableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          const val = totalColumnValues[t.field]
          return val ? format(val) : ''
        })
      result[3] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    setData(data) {
      this.tableData = data
      this.calcTableData = data
    },
    async resetCalcTable() {
      this.calcTableData = await this.getTableData()
      this.$refs.skuTable.updateFooter()
    },
    async remove(row) {
      await this.$refs.skuTable.remove(row)
      this.resetCalcTable()
    },
    async insertAt(records, row = -1) {
      const result = await this.$refs.skuTable.insertAt(records, row)
      await this.resetCalcTable()
      return result
    },
    printView({ hxSkuCode, ncNo, inCtnQty, ctnQty }) {
      this.$refs.printViewRef.open(hxSkuCode, ncNo, inCtnQty, ctnQty)
    },
    async editClosed({ row }) {
      const {
        inCtnQty,
        ctnQty,
        ctnLength,
        ctnWidth,
        ctnHeight,
        ctnGrossWeight,
        ftyPrice,
      } = row

      const goodsQty = multiply(inCtnQty, ctnQty)

      const ctnCbm = divide(
        multiply(multiply(ctnLength, ctnWidth), ctnHeight),
        1000000
      )
      const subCbm = multiply(ctnCbm, ctnQty)
      const subGrossWeight = multiply(ctnGrossWeight, ctnQty)
      const subAmount = multiply(ftyPrice, goodsQty)

      row.goodsQty = goodsQty
      row.subCbm = subCbm
      row.subGrossWeight = subGrossWeight
      row.subAmount = subAmount

      this.resetCalcTable()
    },
    getTableData() {
      const data = this.$refs.skuTable.getTableData()
      return data?.tableData || []
    },
    async validate() {
      const tableData = this.getTableData()
      if (!tableData || !tableData.length) {
        this.$message.error(this.$l('tips_pleaseAddSku') || '请添加产品明细！')
        return false
      }
      const result = await this.$refs.skuTable.validate(true)
      return !result
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
